import { AuditDetails, Entity } from '../entity';
import { MaterialisedViewRunMode, MaterialisedViewRunStatus } from './materialised.view.state';

export enum MaterialisedViewScheduleType {
    Interval = 'interval',
    Cron = 'cron'
}

export interface MaterialisedViewSchedule {
    type: MaterialisedViewScheduleType;
    intervalMinutes?: number;
    cron?: string;
    timezone?: string;
}

export interface MaterialisedViewIndexSpec {
    fields: Record<string, 1 | -1>;
    unique?: boolean;
    partialFilterExpression?: Record<string, any>;
}

export enum MaterialisedViewCommandId {
    Run = 'run',
    Rebuild = 'rebuild'
}

/** Embedded runtime state for a materialised view - updated each run */
export interface MaterialisedViewRuntimeState {
    status: MaterialisedViewRunStatus;
    lastRunAt?: Date;
    nextRunAt?: Date;
    /** Watermark cursor - last updatedAt value processed */
    lastUpdatedAt?: Date;
    /** Watermark cursor - last _id processed (tie-breaker) */
    lastId?: string;
    lastProcessed?: number;
    lastDeleted?: number;
    lastDurationMs?: number;
    /** Job lock expiry - prevents concurrent runs */
    leaseExpiresAt?: Date;
    runId?: string;
    /** Manual run request mode */
    requestedMode?: MaterialisedViewRunMode;
    requestedAt?: Date;
    lastError?: string;
}

export interface MaterialisedViewConfig extends Entity, AuditDetails {
    description?: string;
    viewName: string;
    targetCollection: string;
    enabled: boolean;
    schedule: MaterialisedViewSchedule;
    upsertKeys: string[];
    retentionKeys: string[];
    retentionView: string;
    watermarkField?: string;
    tieBreakerField?: string;
    lookbackMinutes?: number;
    batchSize?: number;
    maxRuntimeMinutes?: number;
    lockTtlMinutes?: number;
    projectionFields?: string[];
    indexSpecs?: MaterialisedViewIndexSpec[];
    /** Embedded runtime state - updated by the sync job */
    state?: MaterialisedViewRuntimeState;
}

export interface MaterialisedViewSource extends Entity {
    viewOn?: string;
}
